import { useMemo } from 'react';
import { useProcInstanceContext } from '@/entities/proc/ProcInstanceContext';
import { Banner } from '@/shared/ui';

export const ProcInstanceDeprecatedBanner = () => {
  const { procInstance } = useProcInstanceContext();

  const bannerMessage = useMemo(() => {
    if (
      procInstance?.stepData.administration.commentsEnabled &&
      procInstance?.stepData.administration.showSubmitButton
    ) {
      return 'Author removed this proc and you cannot comment nor submit it anymore.';
    }
    if (
      !procInstance?.stepData.administration.commentsEnabled &&
      procInstance?.stepData.administration.showSubmitButton
    ) {
      return 'Author removed this proc and you cannot submit it anymore.';
    }
    if (
      procInstance?.stepData.administration.commentsEnabled &&
      !procInstance?.stepData.administration.showSubmitButton
    ) {
      return 'Author removed this proc and you cannot comment it anymore.';
    }
    return null;
  }, [
    procInstance?.stepData.administration.commentsEnabled,
    procInstance?.stepData.administration.showSubmitButton,
  ]);

  return bannerMessage ? <Banner message={bannerMessage} /> : null;
};
